// extracted by mini-css-extract-plugin
export default {"productGrid":"H1-z","centerLink":"I1-z","productSection":"J1-z","item":"K1-z","ctaButton":"L1-z"};